/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseLangListItemViewModelPaginatedResponse } from "../types/CourseLangListItemViewModelPaginatedResponse.ts";
import { courseLangListItemViewModelSchema } from "./courseLangListItemViewModelSchema.ts";

export const courseLangListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => courseLangListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CourseLangListItemViewModelPaginatedResponse>;
